const FREQUENCY_LABELS: Record<string, string> = {
  Tek: 'Tek Sefer',
  Gunluk: 'Her Gün',
  Haftalik: 'Haftalık',
  Aylik: 'Aylık',
  Yillik: 'Yıllık',
  '2Yil': '2 Yılda Bir',
};

export type ReminderUrgency = 'overdue' | 'today' | 'soon' | 'ok';

export function reminderFrequencyLabel(frequency?: string): string {
  if (!frequency) return 'Tek Sefer';
  return FREQUENCY_LABELS[frequency] ?? frequency;
}

export function reminderDaysRemaining(date: string): number {
  const target = new Date(`${date.slice(0, 10)}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86_400_000);
}

export function reminderUrgency(date: string): ReminderUrgency {
  const days = reminderDaysRemaining(date);
  if (days < 0) return 'overdue';
  if (days === 0) return 'today';
  if (days <= 3) return 'soon';
  return 'ok';
}

export function reminderUrgencyLabel(date: string): string {
  const days = reminderDaysRemaining(date);
  if (days < 0) return `Gecikti (${Math.abs(days)} gün)`;
  if (days === 0) return 'Bugün';
  return `${days} gün kaldı`;
}

export const REMINDER_FREQUENCIES = [
  { value: 'Tek', label: 'Tek Seferlik' },
  { value: 'Gunluk', label: 'Her Gün' },
  { value: 'Haftalik', label: 'Haftalık' },
  { value: 'Aylik', label: 'Aylık' },
  { value: 'Yillik', label: 'Yıllık' },
] as const;
